// Service-area pages. Each entry is written for the place itself — housing stock,
// common window styles and what local customers typically ask us for.
export const AREAS = [
  {
    slug: "solihull",
    name: "Solihull",
    intro:
      "From the period semis around Shirley and Olton to the newer estates towards Blythe Valley, Solihull homes suit a huge range of made-to-measure blinds and shutters. We visit with samples, measure every window properly and fit everything ourselves.",
    local:
      "Bay windows are everywhere in Solihull's 1930s semis — Perfect Fit and roman blinds are popular choices there, while shutters suit the larger detached homes around the town centre and Knowle.",
    faqs: [
      {
        q: "Do you charge for a home visit in Solihull?",
        a: "No — the design visit, measuring and written quote are completely free and without obligation, in Solihull as everywhere else we cover.",
      },
      {
        q: "Can you fit blinds in new-build homes?",
        a: "Yes. We're regularly in newer developments around Blythe Valley and Dickens Heath. Perfect Fit blinds are ideal for modern uPVC windows as they clip in without drilling.",
      },
    ],
  },
  {
    slug: "sutton-coldfield",
    name: "Sutton Coldfield",
    intro:
      "We work across Sutton Coldfield — from Four Oaks and Boldmere to Walmley and Mere Green — supplying made-to-measure blinds and shutters for some of the larger homes in the West Midlands, all measured and fitted by our own specialists.",
    local:
      "Larger detached homes here often mean wide windows, patio and bifold doors — vertical blinds, motorised rollers and full-height shutters are the choices we're asked for most in Sutton Coldfield.",
    faqs: [
      {
        q: "Can you cover wide patio or bifold doors?",
        a: "Yes — that's a daily job for us. Motorised roller blinds and panel-style options work beautifully on wide openings, and we measure the whole run precisely at your free visit.",
      },
      {
        q: "Do you offer motorised blinds in Sutton Coldfield?",
        a: "Yes. Quiet rechargeable motors with remote, app or smart-home control — no electrician needed in most cases. We demonstrate the options at your home visit.",
      },
    ],
  },
  {
    slug: "walsall",
    name: "Walsall",
    intro:
      "From the Victorian terraces near the town centre to family homes in Bloxwich, Aldridge and Brownhills, we supply and fit made-to-measure blinds across Walsall — with a free home visit, honest quote and professional fitting as standard.",
    local:
      "Terraced and semi-detached homes around Walsall often have tall, narrow sash-style windows — roller and venetian blinds are the practical favourites, with blackout versions a popular upgrade for bedrooms.",
    faqs: [
      {
        q: "Do you cover all of Walsall?",
        a: "Yes — Walsall town, Bloxwich, Aldridge, Brownhills, Willenhall and Darlaston. If you're on the edge of the area, send your postcode and we'll confirm straight away.",
      },
      {
        q: "Can you blackout a bedroom properly?",
        a: "Yes — blackout fabrics measured precisely to the recess (or fitted exactly outside it) make a genuine difference. We bring blackout samples to your free visit so you can see them in the room's own light.",
      },
    ],
  },
  {
    slug: "west-bromwich",
    name: "West Bromwich",
    intro:
      "We cover West Bromwich and the surrounding Black Country — Great Barr, Stone Cross, Charlemont and beyond — with made-to-measure blinds and shutters, free measuring and fitting by experienced local fitters.",
    local:
      "West Bromwich has plenty of bay-fronted Victorian and Edwardian terraces. Angled bays are where professional measuring really earns its keep — we template each angle so the blinds sit perfectly.",
    faqs: [
      {
        q: "Can you fit blinds to a bay window?",
        a: "Absolutely — bays are one of our specialities. We measure every angle and section individually so each blind fits its own frame with no gaps or rubbing.",
      },
      {
        q: "How much do made-to-measure blinds cost?",
        a: "Every window is different, so we price after measuring — your free home visit ends with a clear written quote and no obligation. Our Price Promise means you won't pay over the odds.",
      },
    ],
  },
  {
    slug: "dudley",
    name: "Dudley",
    intro:
      "Across Dudley, Netherton, Kingswinford and the Merry Hill area, we provide made-to-measure blinds and shutters with free home visits, professional measuring and tidy, expert fitting.",
    local:
      "Homes around Dudley range from older cottages to big modern estates near Merry Hill. Day & night blinds are a local favourite for living rooms — flexible light control without losing the view.",
    faqs: [
      {
        q: "Do you visit evenings or Saturdays?",
        a: "Yes — we arrange visits around work and family life, including Saturday appointments. Just tell us what suits when you book.",
      },
      {
        q: "What are day & night blinds?",
        a: "Alternating sheer and opaque stripes that slide past each other — you dial in anything from full view to full privacy. We bring samples so you can try them against your windows.",
      },
    ],
  },
  {
    slug: "halesowen",
    name: "Halesowen",
    intro:
      "We supply and fit made-to-measure blinds and shutters throughout Halesowen — from the town centre to Hasbury, Lapal and Hayley Green — starting with a free home measure and a clear, no-obligation quote.",
    local:
      "Halesowen's suburban semis and detached homes suit just about everything, but wooden venetians and shutters are the standouts here — especially on the wider windows of Lapal's inter-war houses.",
    faqs: [
      {
        q: "Are wooden venetian blinds heavy to use?",
        a: "Modern wooden venetians are surprisingly light, and we size the controls to the blind. At your free visit you can lift and tilt real samples before deciding.",
      },
      {
        q: "Do shutters work in a semi-detached house?",
        a: "Beautifully — café-style shutters on the ground floor are a popular choice for privacy without losing light, and full-height works upstairs. We measure and fit everything.",
      },
    ],
  },
];
